// interface between the react project and PubNubCenter
// eventually we'll move all that functionality in here and reference
// react-pubnub instead of PubNubCenter.INSTANCE.mPubNub

export const subscribeToRoom = (room, presence) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.subscribeToRoom(room, presence);
};

export const fetchRoomHistory = (room, callback) => {
  //@ts-ignore
  return PubNubCenter.INSTANCE?.fetchRoomHistory(room, (status, response) => {
    callback(status, response);
  });
};

export const addEventListener = (listenerType, callback, scope) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.addEventListener(
    listenerType,
    (event, data) => {
      callback(event, data);
    },
    scope,
  );
};

export const unsubscribeToRoom = room => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.unsubscribeToRoom(room);
};

export const removeEventListenerByScope = (listenerType, scope) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.removeEventListenerByScope(listenerType, scope);
};

export const deleteMessage = (room, timetoken) => {
  var first5digits = timetoken.substr(0, 5);
  var remainingDigits = timetoken.substr(5, timetoken.length - 5);
  var prevTime = first5digits + (parseInt(remainingDigits) - 1).toString();

  //@ts-ignore
  PubNubCenter.INSTANCE?.deleteMessages(
    {
      channel: room,
      start: prevTime,
      end: timetoken,
    },
    result => {
      if (CrowdHub_App.CONFIG.VERBOSE_GENERAL_LOGGING) {
        console.log(result);
      }
    },
  );

  //@ts-ignore
  PubNubCenter.INSTANCE?.removeMessageFromChannel(room, timetoken);
};

export const addMessageAction = (room, timetoken, action) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.addMessageAction(room, timetoken, action, function (response) {});
};

export const removeMessageAction = (room, timetoken, actionTimetoken) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.mPubNub.removeMessageAction({
    channel: room,
    messageTimetoken: timetoken,
    actionTimetoken: actionTimetoken,
  });
};

export const addActionAllMessagesFromUserInChannel = (room, userId, actionType, actionValue) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.addActionAllMessagesFromUserInChannel(room, userId, actionType, actionValue);
};

export const kickUserFromSession = (userId, room) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.mPubNub.signal({
    channel: room,
    message: {
      userId: userId,
      kicker: App.INSTANCE.CurrentUser.Id,
      //@ts-ignore
      type: PubNubPayload.TYPE_KICK_USER,
    },
  });
};

export const banUserFromSession = (userId, room, contentId) => {
  var aUrl = 'custom_api/api_user_banFromSession.php';
  var aVars = { content_id: contentId, ban_user_id: userId };

  //@ts-ignore
  App.INSTANCE.mApi.Request(
    //@ts-ignore
    CrowdHub_App.CONFIG.BASE_URL + aUrl,
    aVars,
    successResponse => {
      if (successResponse.success != 'true') {
        console.error(successResponse);
      }
    },
    errorResponse => {
      console.error(errorResponse);
    },
  );

  //@ts-ignore
  PubNubCenter.INSTANCE?.mPubNub.signal({
    channel: room,
    message: {
      userId: userId,
      kicker: App.INSTANCE.CurrentUser.Id,
      //@ts-ignore
      type: PubNubPayload.TYPE_KICKBAN_USER,
      contentId: contentId,
    },
  });
};

export const messageRoom = (room, message, callback) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.messageRoom(room, message, callback);
};

export const hereNow = (room, includeUUIDs, includeState, callback) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.mPubNub.hereNow(
    {
      channels: [room],
      includeUUIDs: includeUUIDs,
      includeState: includeState,
    },
    (status, response) => {
      callback(status, response);
    },
  );
};

export const getUserMetaData = (uuid, callback) => {
  //@ts-ignore
  PubNubCenter.INSTANCE?.mPubNub.objects.getUUIDMetadata({ uuid: uuid }, (status, result) => {
    callback(status, result);
  });
};

export const getTimeString = timestamp => {
  //@ts-ignore
  return moment(timestamp / 1e4).isSame(moment(), 'day')
    ? //@ts-ignore
      moment(timestamp / 1e4).format('h:mma')
    : //@ts-ignore
      moment(timestamp / 1e4).format('MMM D');
};

export const sortMessagesByVotes = (a, b) => {
  if (CrowdHub_App.CONFIG.SORT_QA_UPVOTES === 'none') {
    return 0;
  }
  if (!a.actions?.upVote?.true?.length && !b.actions?.upVote?.true?.length) {
    return 0;
  }

  if (CrowdHub_App.CONFIG.SORT_QA_UPVOTES === 'bottom') {
    if (!a.actions?.upVote?.true?.length) {
      return -1;
    }
    if (!b.actions?.upVote?.true?.length) {
      return 1;
    }
    return a.actions?.upVote?.true?.length - b.actions?.upVote?.true?.length;
  } else {
    if (!a.actions?.upVote?.true?.length) {
      return 1;
    }
    if (!b.actions?.upVote?.true?.length) {
      return -1;
    }
    return b.actions?.upVote?.true?.length - a.actions?.upVote?.true?.length;
  }
};
